var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalyzePerformance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M75 15.5 63.161 43.173c-.913 2.134-3.8 2.467-5.175.597l-5.214-7.093c-1.278-1.738-3.918-1.6-5.007.263l-5.773 9.873c-1.383 2.366-4.953 1.791-5.524-.889l-3.601-16.9c-.695-3.26-5.394-3.125-5.9.171l-3.47 22.624c-.468 3.042-4.665 3.493-5.767.62L15.605 46.9c-.936-2.442-4.332-2.6-5.49-.254L5 57"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49 65V36M22 65V54M52 65V36M25 65V38M55 65V40M28 65V28M58 65V43M31 65V27M61 65V44M34 65V33M7 65V53M64 65V41M37 65V48M10 65V47M67 65V33M40 65V48M13 65V45M70 65V28M43 65V46M16 65V48M73 65V21M46 65V40M19 65V54"
}))));
export default SvgAnalyzePerformance;